module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@carvana/icons"
var icons_ = __webpack_require__("@carvana/icons");

// CONCATENATED MODULE: ./src/Tooltip/Tooltip.styles.tsx


var Container = external_styled_components_default.a.span.withConfig({
  displayName: "Container",
  componentId: "sc-10dm7ix-0"
})(["font-family:Arial,sans-serif;cursor:pointer;position:relative;display:inline-block;border-bottom:", ";"], function (props) {
  return props.underline && '1px dotted black';
});
var Icon = external_styled_components_default.a.span.withConfig({
  displayName: "Icon",
  componentId: "sc-10dm7ix-1"
})(["background-color:transparent;border-radius:50%;border:1px #757989 solid;color:#757989;display:inline-block;font-size:14px;text-align:center;width:17px;font-weight:bold;"]);
var Title = external_styled_components_default.a.div.withConfig({
  displayName: "Title",
  componentId: "sc-10dm7ix-2"
})(["font-weight:900;color:white;padding-bottom:3px;"]);
var CloseIcon = external_styled_components_default()(icons_["Close"]).withConfig({
  displayName: "CloseIcon",
  componentId: "sc-10dm7ix-3"
})(["color:white;position:absolute;top:", ";right:", ";cursor:pointer;> svg{width:", ";height:", ";}"], function (_ref) {
  var top = _ref.top;
  return (top || 10) + "px";
}, function (_ref2) {
  var right = _ref2.right;
  return (right || 10) + "px";
}, function (_ref3) {
  var width = _ref3.width;
  return (width || 12) + "px";
}, function (_ref4) {
  var height = _ref4.height;
  return (height || 12) + "px";
});

var Tooltip_styles_TopArrow = function TopArrow(_ref5) {
  var direction = _ref5.direction,
      arrowOffsetY = _ref5.arrowOffsetY,
      arrowOffset = _ref5.arrowOffset;
  return direction && direction.includes('top') && Object(external_styled_components_["css"])(["transform:rotate(180deg);top:calc(97% + ", "px);", ";", ";", ";"], arrowOffsetY || 0, direction === 'top-start' && "left: calc(3.5% + " + arrowOffset + "px);", direction === 'top' && "left: calc(43.5% + " + arrowOffset + "px);", direction === 'top-end' && "left: calc(88.5% + " + arrowOffset + "px);");
};

var Tooltip_styles_BottomArrow = function BottomArrow(_ref6) {
  var direction = _ref6.direction,
      arrowOffset = _ref6.arrowOffset,
      arrowOffsetY = _ref6.arrowOffsetY;
  return direction && direction.includes('bottom') && Object(external_styled_components_["css"])(["top:calc(-8px + ", "px);", ";", ";", ";"], arrowOffsetY || 0, direction === 'bottom-start' && "left: calc(3.5% + " + arrowOffset + "px);", direction === 'bottom' && "left: calc(43.5% + " + arrowOffset + "px);", direction === 'bottom-end' && "left: calc(88.5% + " + arrowOffset + "px);");
};

var Tooltip_styles_LeftArrow = function LeftArrow(_ref7) {
  var direction = _ref7.direction,
      arrowOffset = _ref7.arrowOffset,
      arrowPosition = _ref7.arrowPosition;
  return direction && direction.includes('left') && Object(external_styled_components_["css"])(["transform:rotate(90deg);left:calc(98% + ", "px);", ";", ";", ";"], arrowOffset || 0, direction === 'left-start' && "top: calc(" + arrowPosition + "px + " + arrowOffset + "px);", direction === 'left' && "bottom: calc( " + arrowPosition + "px + " + arrowOffset + "px);", direction === 'left-end' && "bottom: calc(" + arrowPosition + "px + " + arrowOffset + "px);");
};

var Tooltip_styles_RightArrow = function RightArrow(_ref8) {
  var direction = _ref8.direction,
      arrowOffset = _ref8.arrowOffset,
      arrowPosition = _ref8.arrowPosition;
  return direction && direction.includes('right') && Object(external_styled_components_["css"])(["transform:rotate(270deg);left:calc(-3.5% + ", "px);", ";", ";", ";"], arrowOffset || 0, direction === 'right-start' && "top: calc(" + arrowPosition + "px + " + arrowOffset + "px);", direction === 'right' && "bottom: calc( " + arrowPosition + "px + " + arrowOffset + "px);", direction === 'right-end' && "bottom: calc(" + arrowPosition + "px + " + arrowOffset + "px);");
};

var Arrow = Object(external_styled_components_["css"])(["&::after{", " ", " ", " ", " border-width:0 8px 8px;content:'';position:absolute;border-style:solid;border-color:", " transparent;display:block;width:0;}"], Tooltip_styles_TopArrow, Tooltip_styles_BottomArrow, Tooltip_styles_LeftArrow, Tooltip_styles_RightArrow, function (props) {
  return props.color || "#183558";
});
var Content = external_styled_components_default.a.span.withConfig({
  displayName: "Content",
  componentId: "sc-10dm7ix-4"
})(["color:white;position:absolute;background-color:", ";padding:15px;font-size:14px;width:", "px;min-height:10px;height:", "px;top:", ";right:", ";bottom:", ";left:", ";border-radius:3px;text-transform:none;", ""], function (props) {
  return props.color || '#183558';
}, function (props) {
  return props.width;
}, function (props) {
  return props.height || 10;
}, function (props) {
  return props.top ? props.top + "px" : '';
}, function (props) {
  return props.right ? props.right + "px" : '';
}, function (props) {
  return props.bottom ? props.bottom + "px" : '';
}, function (props) {
  return props.left ? props.left + "px" : '';
}, function (props) {
  return props.showArrow && Arrow;
});
Content.defaultProps = {
  width: 240
};
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__("react-dom");

// CONCATENATED MODULE: ./src/Tooltip/Portal.tsx



var Portal_TooltipPortal = function TooltipPortal(_ref) {
  var children = _ref.children;
  var tooltipRoot = document.body;
  var el = document.createElement('div');
  Object(external_react_["useEffect"])(function () {
    tooltipRoot.appendChild(el);
    return function () {
      try {
        tooltipRoot.removeChild(el);
      } catch (e) {// node was already removed
      }
    };
  }, []);
  return Object(external_react_dom_["createPortal"])(children, el);
};

/* harmony default export */ var Portal = (Portal_TooltipPortal);
// CONCATENATED MODULE: ./src/helpers/direction-helper.ts
/* harmony default export */ var direction_helper = (function (_ref) {
  var direction = _ref.direction,
      contentHeight = _ref.contentHeight,
      contentWidth = _ref.contentWidth,
      contentOffset = _ref.contentOffset,
      contentOffsetY = _ref.contentOffsetY,
      scrollLeftPosition = _ref.scrollLeftPosition,
      scrollTopPosition = _ref.scrollTopPosition,
      top = _ref.top,
      left = _ref.left,
      right = _ref.right,
      width = _ref.width,
      height = _ref.height;

  switch (direction) {
    case 'top-start':
    case 'top':
    case 'top-end':
      {
        var topStyle = top - contentHeight - 40 + contentOffsetY + scrollTopPosition;

        switch (direction) {
          case 'top-start':
            {
              var leftStyle = left - contentOffset;
              return {
                left: leftStyle,
                top: topStyle
              };
            }

          case 'top-end':
            {
              var _leftStyle = left + width / 2 - Math.floor(contentWidth) - contentOffset;

              return {
                left: _leftStyle,
                top: topStyle
              };
            }

          default:
            {
              var _leftStyle2 = left + width / 2 - Math.floor(contentWidth) / 2 - contentOffset - 5;

              return {
                left: _leftStyle2,
                top: topStyle
              };
            }
        }
      }

    case 'right-start':
    case 'right':
    case 'right-end':
      {
        var _leftStyle3 = right + width / 4 + contentOffset - scrollLeftPosition;

        switch (direction) {
          case 'right-start':
            return {
              left: _leftStyle3,
              top: top + height - (contentHeight - 26) + contentOffsetY + scrollTopPosition,
              arrowPosition: height - 8
            };

          case 'right-end':
            return {
              left: _leftStyle3,
              top: top + height - (contentHeight + 26) + contentOffsetY + scrollTopPosition,
              arrowPosition: height / 2
            };

          default:
            return {
              left: _leftStyle3,
              top: top + height - (contentHeight / 2 + 30) + contentOffsetY + scrollTopPosition,
              arrowPosition: 30
            };
        }
      }

    case 'bottom-end':
    case 'bottom':
    case 'bottom-start':
      {
        var _topStyle = height + top + 10 + contentOffsetY + scrollTopPosition;

        switch (direction) {
          case 'bottom-start':
            {
              var _leftStyle4 = left - contentOffset;

              return {
                left: _leftStyle4,
                top: _topStyle
              };
            }

          case 'bottom-end':
            {
              var _leftStyle5 = left + width / 2 - Math.floor(contentWidth) - contentOffset;

              return {
                left: _leftStyle5,
                top: _topStyle
              };
            }

          default:
            {
              var _leftStyle6 = left + width / 2 - Math.floor(contentWidth) / 2 - contentOffset - 5;

              return {
                left: _leftStyle6,
                top: _topStyle
              };
            }
        }
      }

    case 'left-end':
    case 'left':
    case 'left-start':
      {
        var _leftStyle7 = left - Math.floor(contentWidth) - 40 - contentOffset - scrollLeftPosition;

        switch (direction) {
          case 'left-start':
            return {
              left: _leftStyle7,
              top: height + top - 22 + contentOffsetY + scrollTopPosition,
              arrowPosition: height - 8
            };

          case 'left-end':
            return {
              left: _leftStyle7,
              top: top + height - (contentHeight + 26) + contentOffsetY + scrollTopPosition,
              arrowPosition: height / 2
            };

          default:
            return {
              left: _leftStyle7,
              top: top + height - (contentHeight / 2 + 30) + contentOffsetY + scrollTopPosition,
              arrowPosition: 30
            };
        }
      }

    default:
      return {};
  }
});
// CONCATENATED MODULE: ./src/Tooltip/Tooltip.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable @typescript-eslint/no-explicit-any, jsx-a11y/mouse-events-have-key-events */




var defaultProps = {
  /** shows the little arrow */
  showArrow: true,

  /** which way the tooltip should be going */
  direction: 'bottom',

  /** keeps the tooltip open until closed */
  persist: false,

  /** element the user hovers over to show tooltip */
  hoverElement: external_react_default.a.createElement(Icon, null, "?"),

  /** underlines hoverElement */
  underline: false,

  /** tooltip width */
  width: 250,

  /** tooltip height */
  height: 50,

  /** arrow x offset */
  arrowOffset: 0,

  /** arrow y offset */
  arrowOffsetY: 0,

  /** tooltip x offset */
  contentOffset: 0,

  /** tooltip y offset */
  contentOffsetY: 0,

  /** the whole tooltip color */
  color: undefined,

  /** data-cv-test test id */
  testid: 'tooltip'
};

var Tooltip_Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
      className = _ref.className,
      hoverElement = _ref.hoverElement,
      underline = _ref.underline,
      direction = _ref.direction,
      title = _ref.title,
      contentWidth = _ref.width,
      contentHeight = _ref.height,
      arrowOffset = _ref.arrowOffset,
      arrowOffsetY = _ref.arrowOffsetY,
      contentOffset = _ref.contentOffset,
      contentOffsetY = _ref.contentOffsetY,
      color = _ref.color,
      persist = _ref.persist,
      showArrow = _ref.showArrow,
      testid = _ref.testid;
  var refContainer = Object(external_react_["useRef"])(null);

  var _useState = Object(external_react_["useState"])(false),
      showTooltip = _useState[0],
      setTooltip = _useState[1];

  var _useState2 = Object(external_react_["useState"])({}),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = Object(external_react_["useState"])(false),
      persistTooltip = _useState3[0],
      setPersistTooltip = _useState3[1];

  var setTooltipPosition = function setTooltipPosition() {
    if (showTooltip) return;
    if (persist && persistTooltip) return;

    var _getBoundingClientRec = refContainer.current.getBoundingClientRect(),
        left = _getBoundingClientRec.left,
        right = _getBoundingClientRec.right,
        width = _getBoundingClientRec.width,
        top = _getBoundingClientRec.top,
        height = _getBoundingClientRec.height;

    var scrollTopPosition = document.body.scrollTop || document.documentElement.scrollTop;
    var scrollLeftPosition = document.body.scrollLeft || document.documentElement.scrollLeft;
    setPosition(direction_helper({
      left: left,
      right: right,
      width: width,
      top: top,
      height: height,
      direction: direction,
      contentOffset: contentOffset,
      contentOffsetY: contentOffsetY,
      scrollTopPosition: scrollTopPosition,
      scrollLeftPosition: scrollLeftPosition,
      contentHeight: contentHeight,
      contentWidth: contentWidth
    }));
  };

  var showTooltipFunc = function showTooltipFunc(e) {
    if (!persist) {
      e.stopPropagation();
      setTooltipPosition();
      setTooltip(true);
    }
  };

  var hideTooltipFunc = function hideTooltipFunc(e) {
    if (!persist) {
      e.stopPropagation();
      setTooltip(false);
    }
  };

  var showTooltipOnClick = function showTooltipOnClick(e, force) {
    e.stopPropagation();
    if (!force) setPersistTooltip(true);
    setTooltipPosition();
    setTooltip(true);
    setPersistTooltip(true);
  };

  var closeTooltipOnClick = function closeTooltipOnClick(e) {
    e.stopPropagation();
    setTooltip(false);
    setPersistTooltip(false);
  };

  return external_react_default.a.createElement(Container, {
    onMouseEnter: showTooltipFunc,
    onMouseLeave: hideTooltipFunc,
    onTouchStart: showTooltipOnClick,
    onClick: function onClick(e) {
      return showTooltipOnClick(e, true);
    },
    ref: refContainer,
    underline: underline,
    "data-cv-test": testid + "-container"
  }, hoverElement, showTooltip && external_react_default.a.createElement(Portal, null, external_react_default.a.createElement(Content, _extends({}, position, {
    direction: direction,
    width: contentWidth,
    height: contentHeight,
    arrowOffset: arrowOffset,
    arrowOffsetY: arrowOffsetY,
    color: color,
    showArrow: showArrow,
    className: className,
    "data-cv-test": testid + "-content-wrapper",
    onTouchStart: hideTooltipFunc
  }), title && external_react_default.a.createElement(Title, {
    "data-cv-test": testid + "-title"
  }, title), persist && external_react_default.a.createElement(CloseIcon, {
    "data-cv-test": testid + "-close",
    onClick: closeTooltipOnClick
  }), external_react_default.a.cloneElement(typeof content === 'string' ? external_react_default.a.createElement("div", {
    "data-cv-test": testid + "-content"
  }, content) : content, {
    'data-cv-test': testid + "-content"
  }))));
};

Tooltip_Tooltip.defaultProps = defaultProps;
/* harmony default export */ var src_Tooltip_Tooltip = (Tooltip_Tooltip);
// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport default */__webpack_require__.d(__webpack_exports__, "default", function() { return src_Tooltip_Tooltip; });
/* concated harmony reexport defaultProps */__webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });



/***/ }),

/***/ "@carvana/icons":
/***/ (function(module, exports) {

module.exports = require("@carvana/icons");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom":
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map